<template>
  <div v-if="shirt.id">
    <ul class="nav nav-tabs" role="tablist">
      <li class="active">
        <a
          href="#shirt-order-panel"
          role="tab"
          data-toggle="tab"
          aria-expanded="true"
        >
          Shirt Order Details
        </a>
      </li>
      <li class="">
        <a
          href="#shirt-image-panel"
          role="tab"
          data-toggle="tab"
          aria-expanded="false"
        >
          Manage Images
        </a>
      </li>
      <li class="">
        <a
          href="#shirt-changes-panel"
          role="tab"
          data-toggle="tab"
          aria-expanded="false"
        >
          Shirt Order Changes
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane active" id="shirt-order-panel">
        <div class="grid bg-white">
          <div class="grid-title">
            <h1 class="text-bold">
              #{{ ezy.formatShirtId(shirt) }}
            </h1>
          </div>
          <div class="grid-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Order Number</th>
                  <th class="text-center">Mask Order</th>
                  <th class="text-center">Curly</th>
                  <th class="text-center">Fabric</th>
                  <th class="text-center">C & C Outside</th>
                  <th class="text-center">Contrast</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Age</th>
                  <th class="text-center">Days In Current Step</th>
                  <th class="text-center">Incoming Date</th>
                  <th class="text-center">Document</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-bold">
                    {{ ezy.formatShirtId(shirt) }}
                  </td>
                  <td class="text-center">
                    <span v-if="shirt.mask_order">
                      {{ shirt.mask_order.id }}
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td class="text-center">
                    <span v-if="shirt.curly">
                      {{ shirt.curly.id }}
                    </span>
                    <span v-else> - </span>
                  </td>
                  <td class="text-center">{{ filterZero(shirt.fabric_id) }}</td>
                  <td class="text-center">
                    {{ filterZero(shirt.collar_fabric_id) }}
                  </td>
                  <td class="text-center">
                    {{ filterZero(shirt.inner_collar_fabric_id) }}
                  </td>
                  <td class="text-center">
                    <span v-if="shirt.shirt_order_status">{{
                      shirt.shirt_order_status.title
                    }}</span>
                  </td>
                  <td class="text-center">{{ shirt.age }}</td>
                  <td class="text-center">{{ shirt.days_in_current_step }}</td>
                  <td class="text-center">{{ ezy.date(shirt.created_at) }}</td>
                  <td class="text-center">
                    <print-documents
                      v-if="shirt.shirt_order_status"
                      :shirt="shirt"
                      @click="printCollector"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <div class="row">
                <div class="col-md-12" v-if="shirt.deleted_at">
                  <div class="grid mb-10 bg-danger">
                    <div class="grid-title p-10">
                      <div class="row">
                        <div class="col-md-12">
                          <span class="text-bold text-white">
                            <i class="fa fa-info-circle" aria-hidden="true"></i>
                            Shirt is Deleted
                          </span>
                          <button
                            class="btn btn-white btn-sm"
                            @click="confirmButton('restore')"
                          >
                            Restore
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  v-if="
                    shirt.shirt_order_status_id &&
                    shirt.shirt_order_status_id != 0
                  "
                >
                  <div class="grid mb-10">
                    <div class="grid-title p-10">
                      <div class="row">
                        <div class="col-md-4">
                          <span class="text-bold">CONSULTANT</span> -
                          <span class="text-capitalize"
                            >{{ shirt.consultant.first_name }}
                            {{ shirt.consultant.last_name }} ({{
                              shirt.consultant_id
                            }})</span
                          >
                        </div>
                        <div class="col-md-4" v-if="shirt.client">
                          <span class="text-bold">CLIENT</span> -
                          <span class="text-capitalize"
                            >{{ shirt.client.first_name }}
                            {{ shirt.client.last_name }} ({{
                              shirt.client_id
                            }})</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- shirt Order infos -->
                <div
                  class="col-md-6"
                  v-if="(shirt.shirt_order_status_id && shirt.shirt_order_status_id != 0) || shirt.waiting_reason == 'special_request'"
                >
                  <OrderNotes
                  :notes="shirt.shirt_order_notes"
                  :orderNumber="orderNumber"
                  :isReadOnlyUser="isReadOnlyUser"
                  createRoute="shirt_orders/create/shirt_order_note"
                  updateRoute="shirt_orders/update/shirt_order_note"
                  deleteRoute="shirt_orders/delete/shirt_order_note"
                  title="Shirt Order Infos"
                  orderType="shirt"
                  :currentUser="this.$auth.user()"
                  @update:notes="shirt.shirt_order_notes = $event"
                  />
                </div>

                <!-- shirt Lives -->
                <div class="col-md-6">
                  <div
                    class="grid mb-10 bg-white"
                    v-if="
                      (shirt.shirt_order_status_id &&
                        shirt.shirt_order_status_id != 0) ||
                      checkIfOrderHasWaitingLogs(shirt.shirt_order_history_logs)
                    "
                  >
                    <div class="grid-title">
                      <h4>Shirt Lives</h4>
                    </div>
                    <div class="grid-body shirt-lives-container">
                      <div class="list-group">
                        <div
                          :key="index"
                          v-for="(
                            shirtLife, index
                          ) in shirt.shirt_order_history_logs"
                        >
                          <a
                            class="list-group-item text-capitalize"
                            v-if="shirtLife.shirt_order_status"
                          >
                            <span class="text-bold text-primary">
                              {{ getShirtLifeTitle(shirtLife) }}
                              <span v-if="shirtLife.shelf_box_number">
                                ( {{ shirtLife.shelf_box_number }} )</span
                              >
                              <span
                                v-if="
                                  shirtLife.shirt_order_status_id ==
                                  shirtOrderStatus.SENT_TO_GERMANY
                                "
                              >
                                ( Carton - {{ shirt.karton }} )
                              </span>
                            </span>
                            <span class="float-right">
                              {{ dateFormat(shirtLife.created_at) }}
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- if shirt is remake -->
                  <div class="grid mb-10 bg-white" v-if="shirt.remake">
                    <div class="grid-title">
                      <h4>
                        REMAKE SHIRT AT -
                        <span class="alert alert-danger">{{
                          dateFormat(shirt.remake_start, "MMM DD, YYYY")
                        }}</span>
                      </h4>
                    </div>
                  </div>

                  <!-- if shirt on waiting -->
                  <div class="grid mb-10 bg-white" v-if="shirt.waiting">
                    <div class="grid-title">
                      <div class="row">
                        <div class="col-md-12">
                          <h4>SHIRT IN WAITING</h4>
                          <p>
                            <span class="alert alert-danger">{{
                              getWaitingLabel(shirt.waiting_reason)
                            }}</span>
                          </p>
                          <p>{{ shirt.waiting_notes }}</p>
                        </div>
                        <div class="col-md-12 mb-10 mt-10">
                          <button
                            @click="confirmButton('reset_waiting')"
                            class="btn btn-danger btn-reset"
                            v-if="!isReadOnlyUser"
                          >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                            RESET WAITING
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <!-- additional buttons -->
                  <div class="grid mb-10">
                    <div class="grid-title" v-if="!isReadOnlyUser">
                      <div class="row">
                        <div v-if="shirt.waiting_reason != 'special_request'" class="col-md-6">
                          <button
                            class="btn mb-10 btn-warning btn-block"
                            @click="confirmButton('waiting')"
                          >
                            Add To Waiting List
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button
                            v-if="!shirt.urgent"
                            class="btn mb-10 btn-info btn-block"
                            @click="confirmButton('urgent')"
                          >
                            Add To Urgent List
                          </button>
                          <button
                            v-else
                            class="btn mb-10 btn-info btn-block"
                            @click="confirmButton('reset_urgent')"
                          >
                            Remove From Urgent List
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button
                            class="btn mb-10 btn-success btn-block"
                            @click="confirmButton('remake')"
                            v-if="this.$auth.user().role === 'admin'"
                          >
                            Remake Shirt
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button
                            class="btn mb-10 btn-primary btn-block"
                            @click="confirmButton('finish')"
                          >
                            Finish Shirt Manually
                          </button>
                        </div>
                        <div class="col-md-6">
                          <button
                            class="btn mb-10 btn-danger btn-block"
                            :class="{ disabled: shirt.deleted_at }"
                            @click="confirmButton('delete')"
                          >
                            Delete Shirt
                          </button>
                        </div>
                        <div
                          class="col-md-6"
                          v-if="
                            shirt.shirt_order_status_id &&
                            shirt.shirt_order_status_id != 0
                          "
                        >
                          <button
                            class="btn mb-10 btn-danger btn-block"
                            @click="contactConsultant()"
                          >
                            <i class="fa fa-user" aria-hidden="true"></i>
                            Contact Consultant
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  shirt.shirt_order_status_id &&
                  shirt.shirt_order_status_id != 0
                "
              >
                <adjust-size
                  :size="size"
                  :orderNumber="orderNumber"
                  :is-dress="shirt.is_dress === 1"
                  :isReadOnlyUser="isReadOnlyUser"
                />
                <adjust-lady-size
                  v-if="shirt.type == 'lady'"
                  :size="shirt.lady_size"
                  :isReadyOnlyUser="isReadOnlyUser"
                />
                <adjust-design
                  :shirt="shirt"
                  :pageData="pageData"
                  :isReadOnlyUser="isReadOnlyUser"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="shirt-image-panel">
        <div class="grid shadow bg-white">
          <div class="grid-title">
            <h1 class="text-bold">
              #{{ ezy.formatShirtId(shirt) }}
            </h1>
          </div>
          <div class="grid-body">
            <table class="table table-bordered">
            <thead>
              <tr>
                <th class="sort" @click="sort('id')">Variant Preview</th>
                <th>Variant</th>
                <th class="text-right">
                  <button
                    class="btn btn-success"
                    @click="showCreateImageDialog()"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> Upload
                    New Variant
                  </button>

                  <button class="btn btn-success" @click="reloadImages()">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(image, index) in shirt.images" :key="index">
                <td><img :src="image.image_url" width="100" /></td>
                <td class="text-center" width="100">{{ image.variant }}</td>
                <td class="text-right">
                  <button
                    class="btn btn-primary"
                    @click="showUpdateImageDialog(index)"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i>
                    Edit
                  </button>
                  <button
                    class="btn btn-danger"
                    :class="{ disabled: imageButtonProcessing }"
                    @click="showDeleteImageDialog(index)"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="tab-pane min-h-500" id="shirt-changes-panel">
        <div class="grid bg-white">
          <div class="grid-title">
            <h1 class="text-bold">
              #{{ ezy.formatShirtId(shirt) }}
            </h1>
          </div>
          <div class="grid-body">
              <div class="row d-flex align-items-end">
                <div class="col-md-2">
                  <label>Filter logs by User</label>
                  <select
                    class="form-control search-type"
                    v-model="shirtChanges.filterForm.user_id"
                  >
                    <option
                      v-for="user in shirtChanges.userDropdown"
                      :value="user.id"
                      :key="user.id"
                    >
                      {{ user.full_name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label>Filter logs by Field</label>
                  <select
                    class="form-control search-type"
                    v-model="shirtChanges.filterForm.field"
                  >
                    <option
                      v-for="(value,title) in getMeasurements"
                      :value="value"
                      :key="value"
                    >
                      {{ title }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label>Filter logs by Type</label>
                  <select
                    class="form-control search-type"
                    v-model="shirtChanges.filterForm.type"
                  >
                    <option
                      v-for="searchType in shirtChanges.types"
                      :value="searchType.value"
                      :key="searchType.value"
                    >
                      {{ searchType.title }}
                    </option>
                  </select>
                </div>
                  <div class="col-md-2 mb-10">
                    <label>Filter logs by Date</label>
                    <datepicker
                      :clear-button="true"
                      placeholder="Date From"
                      v-model="shirtChanges.filterForm.dateFrom"
                      input-class="form-control"
                    >
                    </datepicker>
                  </div>
                  <div class="col-md-2 mb-10">
                    <datepicker
                      :clear-button="true"
                      placeholder="Date To"
                      v-model="shirtChanges.filterForm.dateTo"
                      input-class="form-control"
                    >
                    </datepicker>
                  </div>
                  <div class="col-md-1 mb-10">
                    <button
                      class="btn btn-success filter-btn"
                      @click="getShirtChanges()"
                    >
                      <i class="fa fa-search" aria-hidden="true"></i> Filter
                    </button>
                  </div>
                  <div class="col-md-1 mb-10">
                    <button
                      class="btn btn-primary"
                      @click="resetSearchForShirtChanges()"
                    >
                      All
                    </button>
                  </div>
                </div>
                <div class="grid shadow bg-white">
                  <vue-good-table
                    mode="remote"
                    :isLoading.sync="shirtChanges.isLoading"
                    :pagination-options="{
                      enabled: true,
                      mode: 'pages',
                    }"
                    styleClass="table table-bordered data-table"
                    :rows="shirtChanges.changes"
                    :columns="shirtChanges.columns"
                    :totalRows="shirtChanges.totalRecords"
                    @on-sort-change="onSortChange"
                    @on-page-change="onPageChange"
                    @on-per-page-change="onPerPageChange"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'formatted_created_at'">
                        {{ props.row.formatted_created_at }}
                      </span>
                      <span v-else-if="props.column.field == 'field'">
                        {{ props.row.field }}
                      </span>
                      <span v-else-if="props.column.field == 'type'">
                        {{ props.row.type }}
                      </span>
                      <span v-else-if="props.column.field == 'old_value'">
                        {{ props.row.old_value }}
                      </span>
                      <span v-else-if="props.column.field == 'new_value'">
                        {{ props.row.new_value }}
                      </span>
                      <span v-else-if="props.column.field == 'user_full_name'">
                        {{ props.row.user_full_name }}
                      </span>
                      <span v-else-if="props.column.field == 'changed_by'">
                        {{ props.row.changed_by !== null ? props.row.changed_by.toUpperCase() : 'N/A' }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
            </div>
        </div>

      </div>
    </div>

    <div
      class="modal fade"
      id="shirt-upload-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title text-bold"
              v-if="currentImage.variant != null"
            >
              Update Image Variant
            </h5>
            <h5 class="modal-title text-bold" v-else>Create Image Variant</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label for="variant">Variant </label>
              <input
                id="variant"
                type="variant"
                class="form-control slider-value"
                v-model="currentImage.variant"
                placeholder="You can leave this field empty"
              />
            </div>
            <div class="row">
              <ShirtUploadImage
                v-model="currentImage.image_url"
                :error="errors.image_url"
                ref="uploadImageComponent"
              ></ShirtUploadImage>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              :class="{ disabled: imageButtonProcessing }"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: imageButtonProcessing }"
              v-if="currentImage.variant != null"
              @click="updateImage()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: imageButtonProcessing }"
              v-else
              @click="createImage()"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>

    <waiting-info-modal @submit="addToWaiting" />

    <urgent-order-modal @submit="addToUrgent" />

    <delete-shirt-modal @submit="deleteShirt" ref="deleteShirtModal" />

    <restore-shirt-modal @submit="restoreShirt" ref="restoreShirtModal" />
  </div>
</template>

<script>
import printCollector from "./tools/PrintCollector";
import PrintDocuments from "./components/PrintDocuments";
import AdjustSize from "./components/AdjustSize";
import AdjustDesign from "./components/AdjustDesign";
import WaitingInfoModal from "./components/WaitingInfoModal";
import UrgentOrderModal from "./components/UrgentOrderModal";
import RestoreShirtModal from "./components/RestoreShirtModal";
import DeleteShirtModal from "./components/DeleteShirtModal";
import ShirtUploadImage from "./components/ShirtUploadImage";
import _ from "lodash";
import "icheck-bootstrap";
import statusIdToStatus from "@/pages/Tools/statusIdToStatus";
import sidebars from "@/layout/config/sidebars.js";
import AdjustLadySize from "./components/AdjustLadySize";
import Datepicker from "vuejs-datepicker";
import { VueGoodTable } from "vue-good-table";
import OrderNotes from '../Tools/OrderNote.vue';


export default {
  components: {
    PrintDocuments,
    AdjustSize,
    AdjustDesign,
    WaitingInfoModal,
    UrgentOrderModal,
    RestoreShirtModal,
    DeleteShirtModal,
    ShirtUploadImage,
    AdjustLadySize,
    Datepicker,
    VueGoodTable,
    OrderNotes
  },
  data() {
    return {
      shirt: {
        images: [],
      },
      orderNumber: null,
      size: {},
      pageData: {},
      newNote: null,
      waitingReason: null,
      imageButtonProcessing: false,
      currentImage: {
        id: null,
        image_url: null,
        variant: null,
      },
      errors: {},
      isReadOnlyUser: false,
      shirtChanges:{
        isLoading: false,
        columns: [
        { label: 'Date', field: 'formatted_created_at', sortable: true,  thClass: "sort"},
        { label: 'Field Changed', field: 'field', sortable: true,  thClass: "sort"},
        { label: 'Field Type', field: 'type', sortable: true,  thClass: "sort"},
        { label: 'Old Value', field: 'old_value', sortable: false},
        { label: 'New Value', field: 'new_value', sortable: false},
        { label: 'User', field: 'user_full_name', sortable: true, thClass: "sort"},
        { label: 'Changed By', field: 'changed_by', sortable: true, thClass: "sort"},
      ],
        changes: [],
        measurements: [],
        userDropdown:[],
        filterForm: {
          dateFrom: null,
          dateTo: null,
          field: null,
          type: null,
          user_id: null
        },
        currentPage: 1,
        perPage: 10,
        totalRecords: 0,
        types: [
          {
            title: 'Choose Type',
            value: null,
          },
          {
            title: 'Design',
            value: 'design',
          },
          {
            title: 'Size',
            value: 'size',
          },
          {
            title: 'Lady Size',
            value: 'lady_size',
          },
        ],
        sortType: 'asc'
      }
    };
  },
  computed: {
    getMeasurements() {
      if (this.shirtChanges.filterForm.type === 'design') {
        return this.shirtChanges.measurements.designMeasurements;
      } else if (this.shirtChanges.filterForm.type === 'size') {
        return this.shirtChanges.measurements.sizeMeasurements;
      } else if (this.shirtChanges.filterForm.type === 'lady_size') {
        return this.shirtChanges.measurements.ladySizeMeasurements;
      }
    }
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.orderNumber = this.$route.params.id;
    this.getShirtData();
    this.getShirtChanges();
  },
  watch: {
    $route: function () {
      this.orderNumber = this.$route.params.id;
      this.getShirtData();
    },
  },
  methods: {
    async getShirtData() {
      try {
        let res = await axios.get("shirt_orders/detail/" + this.orderNumber);
        this.shirt = res.data.shirt;
        this.shirt.shirt_order_history_logs.sort(function (a, b) {
          return new Date(a.created_at) - new Date(b.created_at);
        });
        this.size = this.shirt.sizes_freeze == null ? {} : this.shirt.sizes_freeze;
        this.pageData = res.data.page_data;
        this.reloadImages();
      } catch (error) {
        switch (error.response.status) {
          case 403:
            toastr.error("Not authorized, please ensure that you have the required permissions.");
            break;
          case 422:
            toastr.error(error.response.data.errors.shirtOrderId);
            break;
          default:
            Swal.fire("# " + this.orderNumber, error.response.data.message, "error");
            break;
        }
      }
    },
    async getShirtChanges() {
      this.shirtChanges.isLoading = true;
      try {
        const params = {
            field: this.shirtChanges.filterForm.field,
            type: this.shirtChanges.filterForm.type,
            date_from: this.shirtChanges.filterForm.dateFrom,
            date_to: this.shirtChanges.filterForm.dateTo,
            user_id: this.shirtChanges.filterForm.user_id,

            page: this.shirtChanges.currentPage,
            per_page: this.shirtChanges.perPage
        };
        let res = await axios.get("shirt_orders/changes/" + this.orderNumber, { params });
        this.shirtChanges.changes = res.data.shirtOrderChanges;
        this.shirtChanges.measurements = res.data.measurements;
        this.shirtChanges.userDropdown = res.data.userDetails;
        this.shirtChanges.totalRecords = res.data.total;
        this.shirtChanges.isLoading = false;
      } catch (error) {
        this.shirtChanges.isLoading = false;
        switch (error.response.status) {
          case 403:
            toastr.error("Not authorized, please ensure that you have the required permissions.");
            break;
          case 422:
            toastr.error(error.response.data.errors.shirtOrderId);
            break;
          default:
            Swal.fire("# " + this.orderNumber, error.response.data.message, "error");
            break;
        }
      }
    },
    resetSearchForShirtChanges() {
      this.shirtChanges.filterForm = {
          dateFrom: null,
          dateTo: null,
          field: null,
          type: null,
          user: null
        };
      this.shirtChanges.currentPage = 1;
      this.getShirtChanges();
      this.shirtChanges.filterForm.type = null;
    },
    filterZero(data) {
      return !data ? "" : $Fabric.getCode(data);
    },
    dateFormat(date, format = "MMM DD, YYYY HH:mm:ss") {
      return moment(date).utc().format(format);
    },
    confirmButton(type) {
      if (type === "waiting") {
        show_modal("#add-waiting");
      } else if (type === "delete") {
        show_modal("#delete-shirt");
      } else if (type === "restore") {
        show_modal("#restore-shirt");
      } else if (type === "urgent") {
        show_modal("#add-urgent");
      } else {
        Swal.fire({
          title: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "CONFIRM",
        }).then((result) => {
          if (result.value) {
            this.changeShirt(type);
          }
        });
      }
    },

    async deleteShirt(deleteFromConsultantSystem) {
      try {
        this.shirt.deleted_at = moment.utc();
        let res = await axios.delete("shirt_orders/delete/" + this.shirt.id, {
          data: {
            delete_consultant: deleteFromConsultantSystem,
          },
        });
        this.$refs.deleteShirtModal.resetModal();
        hide_modal("#delete-shirt");
        Swal.fire("Success", "Successfully Deleted", "success");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.$refs.deleteShirtModal.resetModal();
          hide_modal("#delete-shirt");
          Swal.fire("Failed", "Contact the admins", "error");
        }
      }
    },

    async restoreShirt(restoreInConsultantSystem) {
      try {
        let res = await axios.put("shirt_orders/restore/" + this.shirt.id, {
          restore_consultant: restoreInConsultantSystem,
        });
        this.shirt.deleted_at = null;
        this.$refs.restoreShirtModal.resetModal();
        hide_modal("#restore-shirt");
        Swal.fire("Success", "Successfully restored", "success");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.$refs.restoreShirtModal.resetModal();
          hide_modal("#restore-shirt");
          Swal.fire("Failed", "Contact the admins", "error");
        }
      }
    },

    async addToUrgent(reason) {
      this.shirt["urgent_reason"] = reason;
      await this.changeShirt("urgent");
    },

    async changeShirt(type) {
      let orderNumber = this.shirt.id;

      // to prevent editing of remade shirt triggering the remake call again
      this.shirt["remake"] = 0;

      switch (type) {
        case "remake":
          this.shirt["remake"] = 1;
          this.shirt["shirt_order_status_id"] =
            shirtOrderStatus.DOCUMENT_PRINTED;
          this.shirt["remake_start"] = moment().format("YYYY-MM-DD HH:mm:ss");
          break;
        case "urgent":
          this.shirt["urgent"] = 1;
          break;
        case "reset_urgent":
          this.shirt["urgent"] = 0;
          this.shirt["urgent_reason"] = null;
          break;
        case "reset_waiting":
          this.shirt["waiting"] = 0;
          this.shirt["waiting_reason"] = null;
          this.shirt["waiting_notes"] = null;
          break;
        case "finish":
          this.shirt["shirt_order_status_id"] =
            shirtOrderStatus.SENT_TO_GERMANY;
          break;
      }

      let params = { shirt: this.shirt };
      if (type === "finish") {
        params = { ...params, update_production_status: true };
      }
      if (type === "reset_waiting") {
        params = { ...params, update_waiting: true };
      }

      try {
        let res = await axios.put(
          "shirt_orders/update/shirt_order/" + orderNumber,
          params
        );

        if (res) {
          if (type === "reset_waiting") {
            this.getShirtData();
          }
          if (type === "urgent") {
            hide_modal("#add-urgent");
          }
          Swal.fire("Success", "Successfully Updated", "success");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
    },
    async addToWaiting(params) {
      let orderNumber = this.shirt.id;
      this.shirt["waiting"] = 1;
      this.shirt["waiting_reason"] = params.waiting_reason;
      this.shirt["waiting_notes"] = params.waiting_notes;
      try {
        let res = await axios.put(
          "shirt_orders/update/shirt_order/" + orderNumber,
          {
            shirt: this.shirt,
            update_waiting: true,
          }
        );
        if (res) {
          hide_modal("#add-waiting");
          this.getShirtData();
          Swal.fire("Success", "Successfully Updated", "success");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
    },

    printCollector(params) {
      printCollector(params, (res) => {});
    },

    contactConsultant() {
      this.$router.push(
        `/shirt/contact_consultant/${this.shirt.id}/${this.shirt.consultant.id}`
      );
    },

    showCreateImageDialog() {
      this.currentImage = {
        id: null,
        image_url: null,
        variant: null,
      };
      this.$refs.uploadImageComponent.clearPreview();
      show_modal("#shirt-upload-modal");
    },

    showUpdateImageDialog(index) {
      let image = this.shirt.images[index];
      this.currentImage = {
        id: image.id,
        image_url: image.image_url,
        variant: image.variant,
      };

      this.$refs.uploadImageComponent.setPreview(image.image_url);
      show_modal("#shirt-upload-modal");
    },

    async showDeleteImageDialog(index) {
      let image = this.shirt.images[index];
      this.currentImage = {
        id: image.id,
        image_url: image.image_url,
        variant: image.variant,
      };

      let result = await Swal.fire({
        title: "Are you sure to delete this image ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });
      if (result.value) {
        this.deleteCurrentImage();
      }
    },

    async createImage() {
      let formData = new FormData();
      formData.append("shirt_order_id", this.shirt.id);
      formData.append("image", this.currentImage.image_url);
      formData.append("variant", this.currentImage.variant);

      try {
        this.imageButtonProcessing = true;
        let result = await axios.post(
          "/shirt_orders/" + this.shirt.id + "/images",
          formData
        );
        if (result.data.status === "OK") {
          this.shirt.image_url = result.data.data;
          this.reloadImages();
          toastr.success("Image successfully uploaded");
          hide_modal("#shirt-upload-modal");
        }
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(error.response.data.message);
        }
      }
    },

    async updateImage() {
      let formData = new FormData();
      formData.append("shirt_order_id", this.shirt.id);
      formData.append("image", this.currentImage.image_url);
      formData.append("variant", this.currentImage.variant);
      formData.append("_method", "PUT");

      try {
        this.imageButtonProcessing = true;
        /** see: https://stackoverflow.com/q/54686218 for why are are using a post here! **/
        let result = await axios.post(
          "/shirt_orders/" + this.shirt.id + "/images/" + this.currentImage.id,
          formData
        );
        if (result.data.status === "OK") {
          this.shirt.image_url = result.data.data;
          this.reloadImages();
          toastr.success("Image successfully updated");
          hide_modal("#shirt-upload-modal");
        } else {
        }
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(error.response.data.message);
        }
      }
    },

    async deleteCurrentImage() {
      try {
        this.imageButtonProcessing = true;
        let result = await axios.delete(
          "/shirt_orders/" +
            this.shirt.id +
            "/images/" +
            this.currentImage.variant
        );
        this.shirt.image_url = null;
        this.reloadImages();
        toastr.success("Image deleted");
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(error.response.data.message);
        }
      }
    },

    async reloadImages() {
      let result = await axios.get(
        "/shirt_orders/" + this.shirt.id + "/images"
      );
      if (result.data.status === "OK") {
        this.shirt.images = result.data.data;
      } else {
        toastr.error("There was an error when getting the list of images");
      }
    },

    getShirtLifeTitle(shirtLife) {
      if (shirtLife.waiting === "") {
        return shirtLife.shirt_order_status.title;
      } else {
        return shirtLife.waiting === "IN" ? "Waiting In" : "Waiting Out";
      }
    },

    /**
     * Normally, when a shirt as a status = New Order, the Shirt Lives panel is hidden.
     * But, since we display the Waiting history in that panel as well,
     * we need to check if the shirt have some waiting logs to be displayed and invalidate the previous rule.
     */
    checkIfOrderHasWaitingLogs(history_logs) {
      for (let i in history_logs) {
        if (history_logs[i].waiting !== "") {
          return true;
        }
      }
      return false;
    },

    getWaitingLabel(keyword) {
      let waitingReasons = sidebars.find(
        (element) => element.title === "Waiting"
      );
      let waitingItem = waitingReasons.sub.find(
        (item) => item.keyword === keyword
      );
      return waitingItem.title;
    },

    formatMeasurements(measurements) {
      return measurements.map(measurement => {
        if (measurement.includes('-')) {
          const [label, value] = measurement.split('-');
          return {
            label: label,
            value: value
          };
        } else {
          const snakeCase = measurement.replace(/ /g, '_').toLowerCase();
          return {
            label: measurement,
            value: snakeCase
          };
        }
      });
    },

    onSortChange(column) {
      this.shirtChanges.sortType = this.shirtChanges.sortType == "asc" ? "desc" : "asc";
      this.shirtChanges.changes = _.orderBy(this.shirtChanges.changes, [column[0].field], [this.shirtChanges.sortType]);
    },

    onPerPageChange(params) {
      this.shirtChanges.currentPage = 1;
      this.shirtChanges.perPage = params.currentPerPage;

      this.getShirtChanges();
    },

    onPageChange(params) {
      this.shirtChanges.currentPage = params.currentPage;
      this.getShirtChanges();
    },
  },
};
</script>
<style scoped>
.text-capitalize {
  text-transform: capitalize;
}
.grid {
  margin-bottom: 0px;
}
.grid-title h4 {
  text-overflow: unset !important;
  width: 100% !important;
}
.form-control {
  margin-bottom: 10px;
}
.mb-10 {
  margin-bottom: 10px !important;
}
.mt-10 {
  margin-top: 10px !important;
}
.select {
  width: 100% !important;
}
h4 {
  font-weight: bold !important;
}
.grid-title {
  border-top: 1px solid #eee;
}
.btn-reset {
  margin-top: -8px;
}
.shirt-lives-container {
  max-height: 500px !important;
  overflow: auto;
}
.d-flex {
  display: flex;
}

.align-items-end {
  align-items: end;
}

.min-h-500 {
  min-height: 500px;
}
</style>
